var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-marker"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('message.unread_messages')))]),_c('div',{staticClass:"line"})])}
var staticRenderFns = []

export { render, staticRenderFns }